/* global jQuery, $ */
import {
	OKEVENT,
	subscribeToOkEvent,
} from "shared/util/OkEventHelpers";
import getImageResizerPath from "shared/util/getImageResizerPath";

/*
 * If present, initialize OkPhotos and bind to its events.
 *
 * @param {function} [cb] - A function to run on selection of a photo
 */
export function initializeDesktopPhotos(cb, options) {
	if (!window.OkPhotos) {
		return;
	}

	window.OkPhotos.statsDisabled = true;
	window.OkPhotos.open("upload");
	window.PhotoEditor.captionsDisabled = true;
	window.PhotoFinished.disabled = true;

	// parse some options
	if (options) {
		if (options.captionsEnabled) {
			window.PhotoEditor.captionsDisabled = false;
		}

		if (options.showPhotoFinished) {
			window.PhotoFinished.disabled = false;
		}

		if (options.noReload) {
			window.PhotoFinished.reload = false;
		}

		// update photo uploader rules based on the ablum that the uploader is in
		// and update the success messsage accordingly
		if (options.resetRules && options.source) {
			if (options.source === "album") {
				window.PhotoUploader.setRules(window.PhotoUploader.ruleTypes.album);
			} else {
				window.PhotoUploader.setRules(window.PhotoUploader.ruleTypes.profile);
			}

			window.PhotoFinished.updateSuccessMessage = true;
		}
	}

	// on photo pick (which means that it's been sent to the server, but the
	// crop hasn't been picked yet), save the width and height
	jQuery(document).on("okphotos.picked", (event) => {
		if (typeof (cb) === "function") {
			cb({
				width: event.photo.width,
				height: event.photo.height,
			});
		}
	});

	// on upload completion, set the src, thumb, and crop info
	subscribeToOkEvent(OKEVENT.PhotoUpload, (event) => {
		const thumb = `${getImageResizerPath()}/${event.photo.path}`;

		if (typeof (cb) === "function") {
			cb({
				...event.photo,
				src: event.photo.url,
				thumb,
			});
		}
	});
}


/*
 * Initialize the app's photo flow
 *
 * @param {function} [onSuccess] - A function to run on selection of a photo
 * @param {function} [onCancel] - A function to run on user cancel
 * @param {function} [onFailure] - A function to run on selection of a photo
 */
export function initializeAppPhotos(onSuccess, onCancel, onFailure) {
	if (!window.App || !window.App.showPhotoActions) {
		return;
	}

	// Triggered in js/mobile_app/services/OnboardingWrapper.js. Only set the
	// URL, not the photo object. The photo has already been uploaded and
	// cropped, so we don't want to do uploadPhoto later.
	if (typeof (onSuccess) === "function") {
		$(document).on("AppOnboardingPhoto", (ev, res) => {
			const { allArgs, thumb } = res;
			const { id, width, height } = allArgs;

			onSuccess({
				src: thumb,
				thumb,
				picid: id,
				width,
				height,
			});
		});
	}

	if (typeof (onCancel) === "function") {
		$(document).on("AppOnboardingPhotoCancel", () => {
			onCancel();
		});
	}

	if (typeof (onFailure) === "function") {
		$(document).on("AppOnboardingPhotoFailure", () => {
			onFailure();
		});
	}

	window.App.showPhotoActions();
}


/*
 * Get the center square from a photo.
 *
 * @param {integer} width
 * @param {integer} height
 *
 * @returns {object} blob of coordinates for the image uploader
 */
export function getCenterCrop(width, height) {
	if (!width || !height) {
		return null;
	}

	const size = Math.min(width, height);
	const offset = (Math.max(width, height) - size) / 2;

	let x;
	let y;

	if (width > height) {
		x = offset;
		y = 0;
	} else {
		x = 0;
		y = offset;
	}

	return {
		topLeftX: x,
		topLeftY: y,
		bottomRightX: x + size,
		bottomRightY: y + size,
	};
}



// WEBPACK FOOTER //
// ./src/apps/photo_upload/util/helpers.js